import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import TenantPage from 'layouts/TenantPage';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { maintenanceService } from 'shared/services';
import CloseMaintenanceDialog from '../components/dialog/CloseMaintenanceDialog';
import { MaintenanceColumns } from '../maintenances';

export const WithoutDateMaintenances = () => {
  const translationPrefix = 'pages.maintenance-expiring';

  const { t } = useTranslation();
  const datagridRefresh = useRef(null);

  const [open, setOpen] = useState(false);
  const [maintenanceToCloseId, setMaintenanceToCloseId] = useState<number | null>(null);

  const setOpenDialog = (id: number) => {
    setOpen(true);
    setMaintenanceToCloseId(id);
  };

  const setCloseDialog = () => {
    setOpen(false);
    setMaintenanceToCloseId(null);
  };

  const columns: GridColDef[] = MaintenanceColumns(setOpenDialog, 'expiration');

  return (
    <TenantPage
      title={t(`${translationPrefix}.title-without-date`)}
      subtitle={t(`${translationPrefix}.subtitle-without-date`)}>
      <EnhancedDataGrid
        columns={columns}
        service={maintenanceService}
        getMethod={maintenanceService.getWithoutDateMaintenances}
        refresh={datagridRefresh}
      />
      <CloseMaintenanceDialog
        onClose={setCloseDialog}
        datagridRefresh={datagridRefresh}
        maintenanceId={maintenanceToCloseId}
        isOpen={open}
      />
    </TenantPage>
  );
};

export default WithoutDateMaintenances;
